import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "map-elem-info comment" }
const _hoisted_2 = { class: "col-icon" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "col-info" }
const _hoisted_5 = { class: "row1 mb6" }
const _hoisted_6 = { class: "title-edit" }
const _hoisted_7 = { class: "ib vm comment-type ft-bold" }
const _hoisted_8 = { class: "ib vm username-disp" }
const _hoisted_9 = {
  key: 0,
  class: "ib vm share-scope"
}
const _hoisted_10 = { class: "ib ml8" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "ts ta-right mr8" }
const _hoisted_13 = { class: "row2 mb4" }
const _hoisted_14 = {
  key: 0,
  class: "kp-info-disp"
}
const _hoisted_15 = {
  key: 1,
  class: "angle-disp ml16"
}
const _hoisted_16 = { class: "mr2" }
const _hoisted_17 = { class: "angle-arrow-wrap" }
const _hoisted_18 = {
  key: 2,
  class: "damage-rank-disp ml16"
}
const _hoisted_19 = {
  key: 3,
  class: "move-buttons mr4"
}
const _hoisted_20 = { class: "row3" }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = { class: "row4 mt4 mb2" }
const _hoisted_23 = { class: "file-preview-area" }
const _hoisted_24 = ["src", "onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "file-name" }
const _hoisted_27 = { class: "buttons ta-right mr8" }
const _hoisted_28 = { class: "col-icon" }
const _hoisted_29 = ["src"]
const _hoisted_30 = { class: "col-info edit" }
const _hoisted_31 = { class: "row1 mb8" }
const _hoisted_32 = { class: "title-edit" }
const _hoisted_33 = { class: "form-group comment-type mb0 mr16" }
const _hoisted_34 = ["value"]
const _hoisted_35 = { class: "form-group share-scope mb0 mr16" }
const _hoisted_36 = ["value"]
const _hoisted_37 = {
  key: 0,
  class: "custom-control custom-checkbox mb0 mr16 mt6 update-ts-checkbox"
}
const _hoisted_38 = { class: "row2 mb4" }
const _hoisted_39 = { class: "form-group road-kp mr16" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = ["value"]
const _hoisted_42 = {
  key: 0,
  class: "text-warning kp-warning"
}
const _hoisted_43 = { class: "form-group mr16" }
const _hoisted_44 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_45 = {
  key: 0,
  class: "angle-arrow-wrap ml6"
}
const _hoisted_46 = {
  key: 0,
  class: "form-group damage-rank mb0"
}
const _hoisted_47 = ["value"]
const _hoisted_48 = { class: "row3" }
const _hoisted_49 = { class: "comment-content" }
const _hoisted_50 = { class: "row4 mt4 mb2" }
const _hoisted_51 = { class: "file-select-area" }
const _hoisted_52 = {
  key: 0,
  class: "lbl"
}
const _hoisted_53 = { key: 1 }
const _hoisted_54 = { class: "file-preview-area mt6" }
const _hoisted_55 = ["src", "onClick"]
const _hoisted_56 = { class: "buttons ta-right mr8" }
const _hoisted_57 = ["disabled"]
const _hoisted_58 = {
  key: 0,
  class: "form-group errors"
}

import { onMounted } from 'vue';
import { dtFormat } from 'src/lib/dateHelper';
import type { CommentEditProps, CommentEditEmit } from 'src/models/comment';
import PreviewFilesArea from 'src/components/lib/PreviewFilesArea/index.vue';
import { useCommentEdit } from './useCommentEdit';
import { useCommentDisplay } from './useCommentDisplay';
import { useReactiveMasters } from 'src/composables/useMasters';
import { COMMENT_DAMAGE_RANK_CODES } from 'src/consts/comment_damage_rank';


export default /*@__PURE__*/_defineComponent({
  __name: 'MapElemInfoComment',
  props: {
    isCreateSingleNewElement: { type: Boolean, default: false },
    elem: {},
    forceShowCancelButton: { type: Boolean, default: false },
    updateFailed: { default: 0 },
    createFailed: { default: 0 },
    showMoveButtons: { type: Boolean, default: false }
  },
  emits: ["component-resized", "show-previous", "show-next", "confirm-delete", "area-movie-search", "update", "show-image", "cancel-edit"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const { masters, resolveMastersPromise } = useReactiveMasters();

const {
  state,
  nearKps,
  commentKpObject,
  sortedPreviewFiles,
  startEdit,
  copyLink,
  showPrevious,
  showNext,
  confirmDelete,
  doAreaMovieSearch,
  onSelectedKpObjChanged,
  handleFileUpload,
  initDisplay,
  removeFile,
  save,
  showImage,
  cancelEdit,
  selectImage,
  nearKpThresholdMeters,
  fileTypeIconFromFilePath,
  isImageFileType,
  ACCEPTED_FILE_TYPES,
} = useCommentEdit(props, emit, masters);

const {
  iconPath,
  commentTypeDisp,
  shareScopeDisp,
  contentDisp,
  isParentComment,
  canModerateComment,
  canCopyLink,
  copyLinkTooltip,
  hasValidAngle,
  editIconPath,
  canUpdateTs,
  hasDamageRank,
  editItemHasValidAngle,
  isFixedCandidateImages,
  canSave,
  showCancelButton,
  kpDisp,
  downloadFile,
} = useCommentDisplay(props, state, masters, commentKpObject);

onMounted(async() => {
  await initDisplay();
  await resolveMastersPromise();
});

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(state).mode === 'show')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              class: "resource-icon",
              src: _unref(iconPath)
            }, null, 8, _hoisted_3)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, " 【" + _toDisplayString(_unref(commentTypeDisp)) + "】 ", 1),
                _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(state).comment.userDisplayName), 1),
                (_unref(canModerateComment))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, " (" + _toDisplayString(_unref(shareScopeDisp)) + ") ", 1))
                  : _createCommentVNode("", true),
                (_unref(isParentComment))
                  ? (_openBlock(), _createElementBlock("button", {
                      type: "button",
                      key: "msearch",
                      class: "btn btn-sm btn-secondary ml8",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(doAreaMovieSearch) && _unref(doAreaMovieSearch)(...args)))
                    }, [...(_cache[16] || (_cache[16] = [
                      _createElementVNode("i", { class: "fas fa-search mr2" }, null, -1),
                      _createTextVNode("周辺の動画を検索 ", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm btn-secondary",
                    disabled: !_unref(canCopyLink),
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(copyLink) && _unref(copyLink)(...args)))
                  }, [...(_cache[17] || (_cache[17] = [
                    _createElementVNode("i", { class: "far fa-copy" }, null, -1)
                  ]))], 8, _hoisted_11)
                ])), [
                  [
                    _directive_tooltip,
                    _unref(copyLinkTooltip),
                    void 0,
                    { right: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(dtFormat)(_unref(state).comment.ts, 'yyyy/mm/dd HH:MM')), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              (_unref(state).comment.kpUid)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, " 場所: " + _toDisplayString(_unref(kpDisp)), 1))
                : _createCommentVNode("", true),
              (_unref(hasValidAngle))
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, "方角: " + _toDisplayString(_unref(state).comment.angle) + "°", 1),
                    _createElementVNode("div", _hoisted_17, [
                      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "angle-arrow-bg" }, null, -1)),
                      _createElementVNode("div", {
                        class: "angle-arrow-img",
                        style: _normalizeStyle({ transform: `rotateZ(${_unref(state).comment.angle}deg)`})
                      }, null, 4)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_unref(state).comment.damageRank)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, "判定: " + _toDisplayString(_unref(state).comment.damageRank), 1))
                : _createCommentVNode("", true),
              _cache[21] || (_cache[21] = _createElementVNode("div", { class: "spacer" }, null, -1)),
              (__props.showMoveButtons)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("button", {
                      class: "btn btn-primary btn-xs mr4",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(showPrevious) && _unref(showPrevious)(...args)))
                    }, [...(_cache[19] || (_cache[19] = [
                      _createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1),
                      _createTextVNode(" 前へ ", -1)
                    ]))]),
                    _createElementVNode("button", {
                      class: "btn btn-primary btn-xs",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(showNext) && _unref(showNext)(...args)))
                    }, [...(_cache[20] || (_cache[20] = [
                      _createTextVNode(" 次へ ", -1),
                      _createElementVNode("i", { class: "fas fa-arrow-right" }, null, -1)
                    ]))])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", {
                class: "comment-content",
                innerHTML: _unref(contentDisp)
              }, null, 8, _hoisted_21)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortedPreviewFiles), (file) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: file.id,
                    class: "file-box"
                  }, [
                    (_unref(isImageFileType)(file.path))
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: file.content,
                          class: "image",
                          onClick: ($event: any) => (_unref(showImage)(file))
                        }, null, 8, _hoisted_24))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(["far fa-3x", _unref(fileTypeIconFromFilePath)(file.path)]),
                            onClick: ($event: any) => (_unref(downloadFile)(file))
                          }, null, 10, _hoisted_25),
                          _createElementVNode("div", _hoisted_26, _toDisplayString(file.name), 1)
                        ], 64))
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_27, [
                (_unref(canModerateComment))
                  ? (_openBlock(), _createElementBlock("button", {
                      type: "button",
                      key: "edit",
                      class: "btn btn-sm btn-secondary",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(startEdit) && _unref(startEdit)(...args)))
                    }, " 編集 "))
                  : _createCommentVNode("", true),
                (_unref(canModerateComment))
                  ? (_openBlock(), _createElementBlock("button", {
                      type: "button",
                      key: "delete",
                      class: "btn btn-sm btn-danger ml4",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(confirmDelete) && _unref(confirmDelete)(...args)))
                    }, " 削除 "))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ], 64))
      : _createCommentVNode("", true),
    (_unref(state).mode === 'edit')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("img", {
              class: "resource-icon",
              src: _unref(editIconPath)
            }, null, 8, _hoisted_29)
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _cache[22] || (_cache[22] = _createElementVNode("span", { class: "lbl" }, "種別:", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(state).editItem.commentType) = $event)),
                    class: "custom-select"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(masters).comment.commentTypes, (e) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: e.commentType,
                        value: e.commentType
                      }, " 【" + _toDisplayString(e.commentTypeDisp) + "】 ", 9, _hoisted_34))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _unref(state).editItem.commentType]
                  ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _cache[23] || (_cache[23] = _createElementVNode("span", { class: "lbl" }, "公開範囲:", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(state).editItem.shareScope) = $event)),
                    class: "custom-select"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(masters).lov.shareScopes, (e) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: e.key,
                        value: e.key
                      }, _toDisplayString(e.val), 9, _hoisted_36))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _unref(state).editItem.shareScope]
                  ])
                ]),
                (_unref(canUpdateTs))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: "update_ts",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(state).updateTs) = $event)),
                        class: "custom-control-input"
                      }, null, 512), [
                        [_vModelCheckbox, _unref(state).updateTs]
                      ]),
                      _cache[24] || (_cache[24] = _createElementVNode("label", {
                        class: "custom-control-label",
                        for: "update_ts"
                      }, " 更新を通知 ", -1))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", null, [
                  _cache[26] || (_cache[26] = _createElementVNode("span", { class: "lbl" }, "場所:", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(state).selectedKpObj) = $event)),
                    class: "custom-select",
                    disabled: _unref(nearKps).length === 0,
                    onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_unref(onSelectedKpObjChanged) && _unref(onSelectedKpObjChanged)(...args)))
                  }, [
                    _cache[25] || (_cache[25] = _createElementVNode("option", { value: "" }, null, -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(nearKps), (e, idx) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: idx,
                        value: e
                      }, _toDisplayString(e.locationDisp), 9, _hoisted_41))
                    }), 128))
                  ], 40, _hoisted_40), [
                    [_vModelSelect, _unref(state).selectedKpObj]
                  ])
                ]),
                (_unref(nearKps).length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, " ※" + _toDisplayString(_unref(nearKpThresholdMeters)) + "m以内にKPが見つかりませんでした ", 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _cache[28] || (_cache[28] = _createElementVNode("span", { class: "lbl" }, "方角:", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(state).editItem.angle) = $event)),
                    type: "number",
                    min: "-180",
                    max: "180",
                    class: "ib form-control ta-right angle"
                  }, null, 512), [
                    [_vModelText, _unref(state).editItem.angle]
                  ]),
                  _cache[29] || (_cache[29] = _createElementVNode("span", { class: "ib ml2" }, "°", -1)),
                  (_unref(editItemHasValidAngle))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                        _cache[27] || (_cache[27] = _createElementVNode("div", { class: "angle-arrow-bg" }, null, -1)),
                        _createElementVNode("div", {
                          class: "angle-arrow-img",
                          style: _normalizeStyle({ transform: `rotateZ(${_unref(state).editItem.angle}deg)`})
                        }, null, 4)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_unref(hasDamageRank))
                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                    _cache[31] || (_cache[31] = _createElementVNode("span", { class: "lbl" }, "判定:", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(state).editItem.damageRank) = $event)),
                      class: "custom-select"
                    }, [
                      _cache[30] || (_cache[30] = _createElementVNode("option", { value: null }, null, -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(COMMENT_DAMAGE_RANK_CODES), (code) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: code,
                          value: code
                        }, _toDisplayString(code), 9, _hoisted_47))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _unref(state).editItem.damageRank]
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _withDirectives(_createElementVNode("textarea", {
                  class: "comment-content-textarea",
                  rows: "4",
                  placeholder: "内容を入力してください",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(state).editItem.content) = $event))
                }, null, 512), [
                  [_vModelText, _unref(state).editItem.content]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                (_unref(isFixedCandidateImages))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_unref(state).candidateFiles.length > 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_52, " 添付画像を選択してください。 "))
                        : (_openBlock(), _createElementBlock("span", _hoisted_53, "添付画像")),
                      _createElementVNode("div", _hoisted_54, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).candidateFiles, (image) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: image.id,
                            class: _normalizeClass(["file-box", { 'selected-image': image.selected }])
                          }, [
                            _createElementVNode("img", {
                              src: image.content,
                              class: "image",
                              onClick: ($event: any) => (_unref(selectImage)(image))
                            }, null, 8, _hoisted_55)
                          ], 2))
                        }), 128))
                      ])
                    ], 64))
                  : (_openBlock(), _createBlock(PreviewFilesArea, {
                      key: 1,
                      "preview-files": _unref(sortedPreviewFiles),
                      "is-changeable": true,
                      "accepted-file-types": _unref(ACCEPTED_FILE_TYPES),
                      onFileUpload: _unref(handleFileUpload),
                      onRemoveFile: _unref(removeFile)
                    }, null, 8, ["preview-files", "accepted-file-types", "onFileUpload", "onRemoveFile"]))
              ]),
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("button", {
                  type: "button",
                  key: "save",
                  class: "btn btn-sm btn-primary",
                  disabled: !_unref(canSave),
                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_unref(save) && _unref(save)(...args)))
                }, " 保存 ", 8, _hoisted_57),
                (_unref(showCancelButton))
                  ? (_openBlock(), _createElementBlock("button", {
                      type: "button",
                      key: "cancel",
                      class: "btn btn-sm btn-secondary ml4",
                      onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_unref(cancelEdit) && _unref(cancelEdit)(...args)))
                    }, " キャンセル "))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_unref(state).errorMsgs.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).errorMsgs, (e) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "error",
                      key: e
                    }, _toDisplayString(e), 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})